// #### Recipes ####
const ContactMilestoneRecipe = {
    $type$: 'Recipe',
    name: 'ContactMilestone',
    rule: [
        {
            itemprop: 'milestoneType',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'date',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'label',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'linkedPersonId',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) },
            isId: true,
            optional: true
        },
        {
            itemprop: 'recurring',
            itemtype: { type: 'boolean' }
        }
    ]
};
export default ContactMilestoneRecipe;
//# sourceMappingURL=ContactMilestone-1-0-0.js.map